import { useState } from 'react';
import config from "../config/config";
import { userSession } from '../observers/userObserver';

export const useLoqateAddress = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getValidatedAddress = async (input) => {
    setLoading(true);
    setError(null);
    const token = userSession.getToken()

    try {
      const response = await fetch(`${config["backend-url"]}/api/loqate/verify`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(input), // input must follow the structure shown in your example
      });

      const data = await response.json();
      console.log("Loqate verify response:", data);
//       const data=[
//     {
//       "Input": {
//           "Address1": "2nd Floor, 32-33 Gosfield Street Fit London W1W",
//           "Address2": "",
//           "Country": "United Kingdom",
//           "Locality": "",
//           "PostalCode": ""
//       },
//       "Matches": [
//           {
//               "AQI": "D",
//               "AVC": "P44-I55-P4-089",
//               "Address": "2nd Floor,32-33 Gosfield Street,Fit,London,W1W 6HL",
//               "Address1": "2nd Floor",
//               "Address2": "32-33 Gosfield Street",
//               "Address3": "Fit",
//               "Address4": "London",
//               "Address5": "W1W 6HL",
//               "AddressKey": "33255316",
//               "AdministrativeArea": "London",
//               "AdministrativeAreaISO2": "GB-LND",
//               "AdministrativeCounty": "Westminster",
//               "Country": "GB",
//               "CountryName": "United Kingdom",
//               "DeliveryAddress": "2nd Floor,32-33 Gosfield Street,Fit",
//               "DeliveryAddress1": "2nd Floor",
//               "DeliveryAddress2": "32-33 Gosfield Street",
//               "DeliveryAddress3": "Fit",
//               "DependentLocality": "Fit",
//               "FormerPostalCounty": "London",
//               "HyphenClass": "B",
//               "ISO3166-2": "GB",
//               "ISO3166-3": "GBR",
//               "ISO3166-N": "826",
//               "ISO31662": "Gb",
//               "ISO31663": "Gbr",
//               "Locality": "London",
//               "MatchRuleLabel": "C1ab d1 d1 d6",
//               "PostalCode": "W1W 6HL",
//               "PostalCodePrimary": "W1W 6HL",
//               "PostcodeType": "S",
//               "Premise": "32-33",
//               "PremiseNumber": "32-33",
//               "ResidentialCommercialFlag": "C",
//               "Sequence": "1",
//               "SubBuilding": "2nd Floor",
//               "SubBuildingFloor": "2nd Floor",
//               "Thoroughfare": "Gosfield Street",
//               "ThoroughfareName": "Gosfield",
//               "ThoroughfareTrailingType": "Street",
//               "ThoroughfareType": "Street",
//               "TimeZone_DST": "+01:00",
//               "TimeZone_Name": "Greenwich Mean Time",
//               "TimeZone_UTC": "+00:00",
//               "TraditionalCounty": "Middlesex"
//           }
//       ]
//   }
// ]

      if (Array.isArray(data) && data.length > 0 && data[0].Matches?.length > 0) {
        return data[0].Matches[0]; // Return the first matched address
      } else {
        setError("No verified address found.");
        return null;
      }
    } catch (err) {
      console.error("Loqate verify error:", err);
      setError("Something went wrong. Please try again.");
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { getValidatedAddress, loading, error };
};
